const host = process.env.NODE_ENV_SSR === "staging"
    ? "staging.smmplanner.com"
    : process.env.NODE_ENV_SSR === "staging-io"
        ? "staging.smmplanner.bind.pw"
        : process.env.NODE_ENV_SSR === "production-io"
            ? "smmplanner.io"
            : process.env.NODE_ENV_SSR === "production"
                ? "smmplanner.com"
                : typeof window !== "undefined"
                    ? window.location.host
                    : "localhost";
const WINDOW_ENV = host.includes("smmplanner.io")
    ? "smmplanner.io"
    : host.includes("staging.smmplanner.com")
        ? "staging"
        : host.includes("dev.smmplanner.bind.pw")
            ? "dev"
            : host.includes("staging.smmplanner.bind.pw")
                ? "staging.io"
                : host.includes("smmplanner.com")
                    ? "production"
                    : host.includes("localhost")
                        ? "development"
                        : host.includes("betosha.ru")
                            ? "betosha"
                            : "unknown";
const ENV_VARIABLES_DEFAULT = {
    NODE_ENV: "development",
    REACT_APP__AGREEMENT_EMAIL: WINDOW_ENV === "smmplanner.io" || WINDOW_ENV === "staging.io"
        ? "office@socialmedia-technologies.co.uk"
        : `support@${host}`,
    // App name used to display as window title
    REACT_APP__APP_NAME: "SMMplanner",
    REACT_APP__BASE_PATH: "/home",
    REACT_APP__BILLING_POLICY_REDIRECT_ENABLED: WINDOW_ENV === "production" ||
        WINDOW_ENV === "smmplanner.io" ||
        WINDOW_ENV === "staging" ||
        WINDOW_ENV === "staging.io"
        ? true
        : false,
    REACT_APP__CANVA_API_KEY: WINDOW_ENV === "production" ||
        WINDOW_ENV === "smmplanner.io" ||
        WINDOW_ENV === "staging"
        ? "i5t9LHMvl4MJxKP_KxOGw-29"
        : WINDOW_ENV === "development"
            ? "xdQycEEovwGZFZGE_haTIv7n"
            : WINDOW_ENV === "betosha"
                ? "q7sdCCQ_GqaWeT80NAsRTSPX"
                : undefined,
    // How many last Canva designs will be displayed
    REACT_APP__CANVA_DESIGNS_LIMIT: 10,
    REACT_APP__CARROT_API_KEY: "34503-5ae2f3427f05d0def036662075",
    // Which routes we should track in carrotquest
    REACT_APP__CARROT_EVENTS_ROUTE: '[["/accounts","Аккаунты"],["/affiliate_program", "Партнерская программа"],["/billing","Биллинг"],["/auth/signin","Вход"],["/auth/signup","Регистрация"],["/auth/recovery","Сброс пароля"],["/billing/success", "Успешная оплата"],["/help", "Нужна помощь?"],["/posts","Посты"],["/projects","Проекты"],["/promo","Промо-страницы"],["/repost", "Репостер"],["/reports", "Аналитика"],["/sc", "Конструктор Историй"],["/settings/proxies","Настройки/Прокси"],["/settings/notifications","Настройки/Уведомления"],["/settings/two_factor","Настройки/Двухфакторка"],["/team","Команды"]]',
    // crello.com api key
    REACT_APP__CRELLO_API_KEY: "FiR432wFunoBIeZc64M4hZGpagIUE3",
    REACT_APP__DEBUG: true,
    REACT_APP__ENVIRONMENT: WINDOW_ENV,
    REACT_APP__GET_SITE_CONTROL_KEY: "57568134",
    REACT_APP__GOOGLE_ANALYTICS_ID: WINDOW_ENV === "production" || WINDOW_ENV === "smmplanner.io"
        ? "UA-57245095-1"
        : WINDOW_ENV === "staging" || WINDOW_ENV === "staging.io"
            ? "UA-57245095-9"
            : undefined,
    REACT_APP__GOOGLE_RECAPTCHA_V2_SITE_KEY: WINDOW_ENV === "smmplanner.io" || WINDOW_ENV === "production"
        ? "6LfK4LYdAAAAAGZOGIx82J61Db19S7IqYa6LS9nV"
        : WINDOW_ENV === "staging" || WINDOW_ENV === "staging.io"
            ? "6Lf437YdAAAAAHressx8XsPaDUSQ3yInhsPGq1A5"
            : WINDOW_ENV === "dev"
                ? "6Ld-37YdAAAAAAsAX7SgWgxsZdjHlQO_IA_cKmZR"
                : "6LfE2LYdAAAAAFBm77xDA1IwkzQjQvORXCDA5_KZ",
    REACT_APP__GOOGLE_RECAPTCHA_V3_SITE_KEY: WINDOW_ENV === "smmplanner.io" || WINDOW_ENV === "production"
        ? "6Ler79oUAAAAAC2xcmA3SGWEB6Xzam4ddVlyg_95"
        : WINDOW_ENV === "staging" || WINDOW_ENV === "staging.io"
            ? "6LcNvtoUAAAAAAUszdV-r39JV44bxhorQGaSF2n5"
            : WINDOW_ENV === "dev"
                ? "6LeLCXgUAAAAACPVbnf5c1VyDCRqdGhlDg2pnTmT"
                : "6Lff4p0UAAAAALwj6RxqgUpxKcNpW_g0aOVTRId_",
    REACT_APP__GOOGLE_TAG_MANAGER_ID: WINDOW_ENV === "production" || WINDOW_ENV === "smmplanner.io"
        ? "GTM-KD87NVT"
        : WINDOW_ENV === "staging" || WINDOW_ENV === "staging.io"
            ? "GTM-N654MSR"
            : undefined,
    REACT_APP__INTERCOM_APP_ID: WINDOW_ENV === "production" || WINDOW_ENV === "smmplanner.io"
        ? "nyh3y1xd"
        : "juetlohv",
    // Interval (in ms) to check if current frontend version is actual
    REACT_APP__INTERVAL_VERSION_CHECK: 600000,
    REACT_APP__IS_FOREIGN: WINDOW_ENV === "smmplanner.io" || WINDOW_ENV === "staging.io"
        ? true
        : false,
    // Location change repeats per minute
    REACT_APP__LCRPM: 10,
    REACT_APP__POLOTNO_API_KEY: "fOf_-S96r35fkm-ZOU8C",
    REACT_APP__RECAPTCHA_TOKEN: "",
    // To use sentry, specify it's key
    REACT_APP__SENTRY_DSN: "https://5f3a7ad1cce84857ab7fe6b68e853883@sentry.bind.pw/12",
    REACT_APP__SMP_ART_GALLERY_IMAGE_MAX_SIZE: 1920,
    REACT_APP__SUPPORT_EMAIL: `support@${host}`,
    // Maximum time (in ms) to load font
    REACT_APP__TIMEOUT_IMPORT: 15000,
    // Time (in ms) before force reload page to get latest app version
    REACT_APP__TIMEOUT_VERSION_AS_FORCE: 180000,
    REACT_APP__URL_DATAFAN_BASE: {
        betosha: "https://dev.datafan.pro",
        dev: "https://dev.datafan.pro",
        development: "https://dev.datafan.pro",
        production: "https://datafan.pro",
        "smmplanner.io": "https://datafan.pro",
        staging: "https://dev.datafan.pro",
        "staging.io": "https://dev.datafan.pro",
        unknown: "https://dev.datafan.pro",
    }[WINDOW_ENV],
    REACT_APP__URL_EASYPOST_BASE: (typeof window !== "undefined" &&
        (host === "localhost" || host.startsWith("localhost:"))
        ? window.location.origin
        : host === "localhost"
            ? `http://localhost`
            : `https://${host}`) + "/",
    REACT_APP__URL_GIPHY: "",
    REACT_APP__URL_GRAPHQL: "/graphql",
    REACT_APP__URL_PROXY_LOCAL: "",
    REACT_APP__URL_SMP_API: "",
    REACT_APP__URL_SMP_WS: "",
    REACT_APP__URL_STATIC_ICONS: "/static/icons/",
    // statics bucket URL
    REACT_APP__URL_STORAGE_STATIC: "https://assets.smmplanner.com",
    REACT_APP__VERSION: "",
    REACT_APP__BUILD_ID: "",
    // Attempts to reload app to get target version
    REACT_APP__VERSION_RELOAD_ATTEMPTS: 3,
    REACT_APP__WS_CONNECTION_TIMEOUT: 10000,
    REACT_APP__WS_RECONNECT_ATTEMPTS_LEGAL: 5,
    // Delay (in ms) before reconnect (stompjs)
    REACT_APP__WS_RECONNECT_DELAY: 200,
    REACT_APP__WS_TOKEN_REQUEST_ATTEMPTS_LEGAL: 5,
    REACT_APP__YANDEX_METRIKA_COUNTER: WINDOW_ENV === "production" || WINDOW_ENV === "smmplanner.io"
        ? 27318218
        : WINDOW_ENV === "staging" || WINDOW_ENV === "staging.io"
            ? 93965929
            : undefined,
    REACT_APP__SMP_MAX_BOT_ID: WINDOW_ENV === "production" || WINDOW_ENV === "smmplanner.io"
        ? "121522926545"
        : "121522926545",
    REACT_APP__BILLING_PADDLE_CLIENT_SIDE_TOKEN: WINDOW_ENV === "production" || WINDOW_ENV === "smmplanner.io"
        ? undefined
        : "test_e025c55732781998fa3b3201da9",
    REACT_APP__CANVA_CONNECT_API_URL: WINDOW_ENV === "development" ? "/canva-rest" : "https://api.canva.com/rest",
};
const ensureEnvVariables = (variables) => {
    const processEnvVariables = {};
    for (let key in process.env) {
        if (variables.hasOwnProperty(key)) {
            const envVal = process.env[key];
            if (envVal === "true") {
                processEnvVariables[key] = true;
            }
            else if (envVal === "false") {
                processEnvVariables[key] = false;
            }
            else {
                if (envVal !== undefined && !isNaN(+envVal)) {
                    processEnvVariables[key] = +envVal;
                }
                else {
                    processEnvVariables[key] = envVal;
                }
            }
        }
    }
    return Object.assign(Object.assign({}, variables), processEnvVariables);
};
export const { NODE_ENV, REACT_APP__AGREEMENT_EMAIL, REACT_APP__APP_NAME, REACT_APP__BASE_PATH, REACT_APP__BILLING_POLICY_REDIRECT_ENABLED, REACT_APP__CANVA_API_KEY, REACT_APP__CANVA_DESIGNS_LIMIT, REACT_APP__CARROT_API_KEY, REACT_APP__CARROT_EVENTS_ROUTE, REACT_APP__CRELLO_API_KEY, REACT_APP__DEBUG, REACT_APP__ENVIRONMENT, REACT_APP__GET_SITE_CONTROL_KEY, REACT_APP__GOOGLE_ANALYTICS_ID, REACT_APP__GOOGLE_RECAPTCHA_V2_SITE_KEY, REACT_APP__GOOGLE_RECAPTCHA_V3_SITE_KEY, REACT_APP__GOOGLE_TAG_MANAGER_ID, REACT_APP__INTERCOM_APP_ID, REACT_APP__INTERVAL_VERSION_CHECK, REACT_APP__IS_FOREIGN, REACT_APP__LCRPM, REACT_APP__POLOTNO_API_KEY, REACT_APP__RECAPTCHA_TOKEN, REACT_APP__SENTRY_DSN, REACT_APP__SUPPORT_EMAIL, REACT_APP__TIMEOUT_IMPORT, REACT_APP__TIMEOUT_VERSION_AS_FORCE, REACT_APP__URL_DATAFAN_BASE, REACT_APP__URL_EASYPOST_BASE, REACT_APP__URL_GIPHY, REACT_APP__URL_GRAPHQL, REACT_APP__URL_PROXY_LOCAL, REACT_APP__URL_SMP_API, REACT_APP__URL_SMP_WS, REACT_APP__URL_STORAGE_STATIC, REACT_APP__URL_STATIC_ICONS, REACT_APP__VERSION, REACT_APP__VERSION_RELOAD_ATTEMPTS, REACT_APP__WS_CONNECTION_TIMEOUT, REACT_APP__WS_RECONNECT_ATTEMPTS_LEGAL, REACT_APP__WS_RECONNECT_DELAY, REACT_APP__WS_TOKEN_REQUEST_ATTEMPTS_LEGAL, REACT_APP__YANDEX_METRIKA_COUNTER, REACT_APP__SMP_ART_GALLERY_IMAGE_MAX_SIZE, REACT_APP__BUILD_ID, REACT_APP__SMP_MAX_BOT_ID, REACT_APP__BILLING_PADDLE_CLIENT_SIDE_TOKEN, REACT_APP__CANVA_CONNECT_API_URL, } = ensureEnvVariables(ENV_VARIABLES_DEFAULT);
//# sourceMappingURL=env.js.map